import { fetch as standaloneFetch } from '@nackle/studio-tools';
import { useFetch } from '@nackle/umbrella-studio';
import createCmxService from '../services/cmx';

const useCmxService = ( isUmbrella ) => {
  if ( !isUmbrella ) {
    return createCmxService( standaloneFetch );
  }

  const umbrellaFetch = useFetch();
  return createCmxService( umbrellaFetch );
};

export default useCmxService;
